// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__SNfeN","options":"AnswerScale_options__2N5FC","selected":"AnswerScale_selected__20p7O"};